module.exports = __webpack_public_path__ + "static/img/RAPD1-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD1-G_1.png
// module id = JPrx
// module chunks = 0